export default [
  'tqueue',
  'avgqueue',
  'maxqueue',
  'tringing',
  'avgringing',
  'maxringing',
  'ttqueued',
  'avgqueued',
  'maxqueued',
  'ttwait',
  'avgwait',
  'maxwait',
  'ttring',
  'avgring',
  'maxring',
  'ttanswer',
  'avganswer',
  'maxanswer',
  'tthelded',
  'avghelded',
  'maxhelded',
  'minqueue',
  'minringing',
  'minqueued',
  'minwait',
  'minring',
  'minanswer',
  'minhelded',
  'login',
  'extStatusTime',
  'lastRec',
  'tStatus',
  'start',
  'statusTime'
];
